import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const httpRequestInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	const token = authService.getToken();

	req = req.clone({
		headers: req.headers.set('Authorization', token ? `Token ${token}` : '')
	});

	return next(req);
};
